"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M3.997 13.552C4.463 9.127 8.178 6.875 12 6.875s7.537 2.252 8.003 6.677a.5.5 0 0 0 .994-.104C20.463 8.373 16.178 5.875 12 5.875s-8.463 2.498-8.997 7.573a.5.5 0 0 0 .994.104"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 9.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
  })]
}), 'Visibility');
